import React, { useEffect, useState } from "react";
import Box from "../../elements/box/Box";
import {
  PencilIcon,
  TrashIcon,
  MailIcon,
  LockClosedIcon,
  LockOpenIcon,
} from "@heroicons/react/outline";
import { Helmet } from "react-helmet-async";
import { Link } from "react-router-dom";
import axiosAPI from "../../utils/axios-api";
import SMModal from "../../elements/modals/SMModal";
import ButtonPrimary from "../../elements/button/ButtonPrimary";
import SMSwitch from "../../elements/switch/SMSwitch";
import SkeletonCard from "../../elements/loading/SkeletonCard";
import NotFound from "../../elements/not-found/NotFound";
import swal from 'sweetalert2'

const API = process.env.REACT_APP_API;
export default function DaftarKuisioner() {
  const [kuesioner, setkuesioner] = useState([]);
  const [modalDelete, setmodalDelete] = useState(null);
  const [dataUser, setdataUser] = useState({});
  const [loadingGetData, setloadingGetData] = useState(0);

  const [nextPaginate, setNextPaginate] = useState(0);
  const [prevPaginate, setPrevPaginate] = useState(0);
  const [currentPage, setCurrentPage] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const [perPage, setPerPage] = useState(0);
  const [fromPage, setFromPage] = useState(0);
  const [toPage, setToPage] = useState(0);
  const [showPerPage, setShowPerPage] = useState(0);

  useEffect(() => {
    let datauser = JSON.parse(localStorage.getItem("authenticatedUser")) ?? {};
    setdataUser(datauser);
    getKuesioner();
  }, []);

  function getKuesioner(params) {
    setloadingGetData(1);
    let datauser = JSON.parse(localStorage.getItem("authenticatedUser")) ?? {};
    let pageSize = showPerPage ? showPerPage : 10 
    
    axiosAPI
      .get(
        API +
          "kuesioner/list-kuesioner?page[size]=10&page[number]=1&sort=-created_at&filter[user_id]=" +
          datauser.id
      )
      .then((res) => {
        setloadingGetData(2);
        
        setNextPaginate(res.data.meta.current_page + 1)
        setPrevPaginate(res.data.meta.current_page - 1)
        setCurrentPage(res.data.meta.current_page)
        setLastPage(res.data.meta.last_page)
        setPerPage(res.data.meta.per_page)
        setFromPage(res.data.meta.from)
        setToPage(res.data.meta.to)
        
        setkuesioner(res.data.data);
        if (res.data.data.length === 0) {
          setloadingGetData(4);
        }
      })
      .catch((err) => {
        setloadingGetData(3);
      });
  }

  // paginate
  function nextPage(){

    let nextPage = nextPaginate;
    let pageNow = currentPage;
    let pageLast = lastPage;
    let pageSize = showPerPage ? showPerPage : 10 

    if( pageNow >= pageLast ){
      return false;
    }else{
      let datauser = JSON.parse(localStorage.getItem("authenticatedUser")) ?? {};
    
      axiosAPI
        .get(
          API +
            "kuesioner/list-kuesioner?page[size]="+ pageSize +"&page[number]="+ nextPage +"&sort=-created_at&filter[user_id]=" +
            datauser.id
        )
        .then((res) => {
          setloadingGetData(2);
          
          setNextPaginate(res.data.meta.current_page + 1)
          setPrevPaginate(res.data.meta.current_page - 1)
          setCurrentPage(res.data.meta.current_page)
          setLastPage(res.data.meta.last_page)
          setPerPage(res.data.meta.per_page)
          setFromPage(res.data.meta.from)
          setToPage(res.data.meta.to)
          
          setkuesioner(res.data.data);
          if (res.data.data.length === 0) {
            setloadingGetData(4);
          }
        })
        .catch((err) => {
          setloadingGetData(3);
        });

    }

  }

  function prevPage(){
    let prevPage = prevPaginate;
    let pageNow = currentPage;
    let pageLast = lastPage;
    let pageSize = showPerPage ? showPerPage : 10 

    if( pageNow === 1 ){
      return false;
    }else{
      let datauser = JSON.parse(localStorage.getItem("authenticatedUser")) ?? {};
    
      axiosAPI
        .get(
          API +
            "kuesioner/list-kuesioner?page[size]="+ pageSize +"&page[number]="+ prevPage +"&sort=-created_at&filter[user_id]=" +
            datauser.id
        )
        .then((res) => {
          setloadingGetData(2);
          
          setNextPaginate(res.data.meta.current_page + 1)
          setPrevPaginate(res.data.meta.current_page - 1)
          setCurrentPage(res.data.meta.current_page)
          setLastPage(res.data.meta.last_page)
          setPerPage(res.data.meta.per_page)
          setFromPage(res.data.meta.from)
          setToPage(res.data.meta.to)
          
          setkuesioner(res.data.data);
          if (res.data.data.length === 0) {
            setloadingGetData(4);
          }
        })
        .catch((err) => {
          setloadingGetData(3);
        });

    }

  }

  function gotoPage(params){

        let datauser = JSON.parse(localStorage.getItem("authenticatedUser")) ?? {};
        let pageSize = showPerPage ? showPerPage : 10 
        
        axiosAPI
        .get(
            API +
            "kuesioner/list-kuesioner?page[size]="+ pageSize +"&page[number]="+ params +"&sort=-created_at&filter[user_id]=" +
            datauser.id
        )
        .then((res) => {
            setloadingGetData(2);
            
            setNextPaginate(res.data.meta.current_page + 1)
            setPrevPaginate(res.data.meta.current_page - 1)
            setCurrentPage(res.data.meta.current_page)
            setLastPage(res.data.meta.last_page)
            setPerPage(res.data.meta.per_page)
            setFromPage(res.data.meta.from)
            setToPage(res.data.meta.to)
            
            setkuesioner(res.data.data);
            if (res.data.data.length === 0) {
            setloadingGetData(4);
            }
        })
        .catch((err) => {
            setloadingGetData(3);
        });

  }

  function showPage(params){
    let datauser = JSON.parse(localStorage.getItem("authenticatedUser")) ?? {};
    setShowPerPage(params)
        
    axiosAPI
    .get(
        API +
        "kuesioner/list-kuesioner?page[size]="+ params +"&page[number]="+ currentPage +"&sort=-created_at&filter[user_id]=" +
        datauser.id
    )
    .then((res) => {
        setloadingGetData(2);
        
        setNextPaginate(res.data.meta.current_page + 1)
        setPrevPaginate(res.data.meta.current_page - 1)
        setCurrentPage(res.data.meta.current_page)
        setLastPage(res.data.meta.last_page)
        setPerPage(res.data.meta.per_page)
        setFromPage(res.data.meta.from)
        setToPage(res.data.meta.to)
        
        setkuesioner(res.data.data);
        if (res.data.data.length === 0) {
        setloadingGetData(4);
        }
    })
    .catch((err) => {
        setloadingGetData(3);
    });
  }
  
  function _delete(params) {
    axiosAPI.post(API + "kuesioner/delete", { id: params }).then((res) => {
      setmodalDelete(null)
      getKuesioner();
    });
  }

    function _publish(params, status) {
        axiosAPI
            .post(API + "kuesioner/" + params + "/publish", { status: status })
            .then((res) => {
                
                if( res.data.status === "success" ){
                    swal.fire('Berhasil', res.data.message, 'success');
                }else{
                    swal.fire('Gagal', res.data.message, 'error');
                }

                setkuesioner([]);
                getKuesioner();
            });
    }

  function renderData() {
    switch (loadingGetData) {
      case 1:
        return (
          <div>
            <SkeletonCard />
            <SkeletonCard />
            <SkeletonCard />
          </div>
        );
        break;
      case 2:
        return (
          <>
            {kuesioner.map((val, idx) => {
              return (
                <Box>
                  <Helmet>
                    <title>Daftar Kuesioner</title>
                  </Helmet>
                  <div className="flex flex-col">
                    <div className="flex flex-row">
                      <div className="w-10/12">
                        <div className="flex flex-row items-center">
                          {/* <UserCircleIcon className="h-10 w-10 m-2" /> */}
                          <div className="flex-1 flex flex-col pr-4">
                            <h1 className="text-md font-bold">{val.kode_kuesioner}</h1>
                            <div className="flex flex-row gap-2">
                              <p className="text-sm text-blue-500">
                                {val.tanggal_buka} {"<->"}
                              </p>
                              <p className="text-sm text-blue-500">
                                {val.tanggal_tutup}
                              </p>
                            </div>
                          </div>
                        </div>

                        <div className="flex py-6 flex-col">
                          <h1 className="text-xl font-bold">{val.judul}</h1>
                          <p className="text-xs">{val.keterangan}</p>
                        </div>
                      </div>
                      <div className="w-2/12 flex flex-col p-2 text-center">
                        <span className="py-2 px-4 rounded bg-blue-100 dark:bg-blue-300 text-blue-600 font-bold text-sm">
                          {val.poin} Poin
                        </span>
                        <span className="py-2 px-4 rounded bg-yellow-100 dark:bg-yellow-100 my-2 text-yellow-600 dark:text-yellow-900 font-bold text-sm">
                          {val.scoin} Scoin
                        </span>
                      </div>
                    </div>
                    <div className="flex flex-col">
                      <div className="flex flex-row items-center">
                        <span className="py-2 my-2 mr-2 px-4 rounded bg-blue-100 dark:bg-blue-300 text-blue-600 text-sm">
                          {(val.tipe === 0) ? "Pilihan Ganda" : (val.tipe === 1) ? "File" : "Liklert" }
                        </span>
                        <span className="py-2 my-2 mr-2 px-4 rounded bg-blue-100 dark:bg-blue-300 text-blue-600 text-sm">
                          {val.sifat === 0 ? (
                            <LockOpenIcon className="h-6 w-6" />
                          ) : (
                            <LockClosedIcon className="h-6 w-6" />
                          )}
                        </span>
                        <div className="flex flex-row gap-2 items-center">
                          {val.sifat === 0 ? (
                            <>
                              <p className="text-sm text-green-500">
                                Posting di Bursa
                              </p>
                              <SMSwitch
                                onChange={() => {
                                  val.status === 1
                                    ? _publish(val.id, 0)
                                    : _publish(val.id, 1);
                                }}
                                status={val.status === 1}
                              />
                            </>
                          ) : null}
                        </div>
                      </div>

                      <div className="flex flex-row justify-between">
                        <div className="flex flex-row">
                          <Link to={`/undang-kuesioner/${val.id}`}>
                            <MailIcon className="h-8 w-8 mx-2" />
                          </Link>
                          <Link to={`/edit/${val.id}`}>
                            <PencilIcon className="h-8 w-8 mx-2" />
                          </Link>
                          <span className="border-r-2 mx-2 border-gray-300"></span>
                          <button onClick={() => setmodalDelete(val.id)}>
                            <TrashIcon className="h-8 w-8 mx-2" />
                          </button>
                        </div>

                        <div>
                          <div className="grid grid-flow-col grid-cols-2 gap-2">
                            {/* <Link to="/detail-kuesioner?type=1">
                            <button className="justify-center px-4 py-2 flex flex-row items-center rounded-lg bg-blue-500 text-white">
                              <p className="text-xs">Lihat hasil kuesioner</p>
                            </button>
                          </Link> */}

                            <Link to={`/hasil-kuesioner/${val.id}`}>
                              <button className="justify-center px-4 py-2 flex flex-row items-center rounded-lg bg-blue-500 text-white">
                                <p className="text-xs">Lihat hasil kuesioner</p>
                              </button>
                            </Link>

                            <a
                              href={val.file_panduan}
                              download
                              target="_blank"
                              className="justify-center px-4 py-2 flex flex-row items-center rounded-lg border border-blue-500 text-blue-500"
                            >
                              <p className="text-xs">Panduan</p>
                            </a>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Box>
              );
            })}

            
            <div class="flex">

                <div class="inline-flex mt-2 xs:mt-0">

                    <button onClick={() => prevPage()} class="inline-flex items-center py-2 px-2 mr-3 text-sm font-medium text-gray-500 bg-white rounded-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                        <svg class="mr-2 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M7.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L5.414 9H17a1 1 0 110 2H5.414l2.293 2.293a1 1 0 010 1.414z" clip-rule="evenodd"></path>
                        </svg>
                    </button>

                    <button onClick={() => nextPage()} class="inline-flex items-center py-2 px-2 text-sm font-medium text-gray-500 bg-white rounded-lg border border-gray-300 hover:bg-gray-100 hover:text-gray-700 dark:bg-gray-800 dark:border-gray-700 dark:text-gray-400 dark:hover:bg-gray-700 dark:hover:text-white">
                        <svg class="ml-2 w-5 h-5" fill="currentColor" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" d="M12.293 5.293a1 1 0 011.414 0l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-2.293-2.293a1 1 0 010-1.414z" clip-rule="evenodd"></path>
                        </svg>
                    </button>

                </div>

                <span class="text-sm text-gray-700 dark:text-gray-400 mt-4 ml-3 xs:mt-0 font-medium">
                      {fromPage} - {toPage} Dari {lastPage} Page |
                    <input class="shadow appearance-none border rounded w-20 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ml-2" type="number" name="" id="" onChange={evt => gotoPage(evt.target.value)} value={currentPage} />

                    <select class="shadow appearance-none border rounded w-20 py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline ml-2" name="" id="" onChange={evt => showPage(evt.target.value)}>
                        {/* <option value="5">Show 5</option> */}
                        <option value="10">Show 10</option>
                        <option value="30">Show 30</option>
                        <option value="40">Show 40</option>
                        <option value="50">Show 50</option>
                    </select>

                </span>

            </div>

        </>
        );
        break;
    case 3:
        return <div>error</div>;
        break;
    case 4:
        return (
            <div>
                <NotFound />
            </div>
        );
        break;

    default:
        break;
    }
  }
  return (
    <>
      {/* SM Modal */}
      <SMModal
        title="Konfirmasi"
        show={!!modalDelete}
        onClose={() => setmodalDelete(null)}
      >
        <div className="flex flex-col p-4">
          <p>Yakin ingin menghapus kuesioner ini {modalDelete}</p>
          <div className="flex flex-row gap-2 py-4">
            <ButtonPrimary
              onClick={() => setmodalDelete(null)}
              text="Batal"
              type="solid"
            />
            <ButtonPrimary
              onClick={() => _delete(modalDelete)}
              text="Hapus"
              type="outline"
            />
          </div>
        </div>
      </SMModal>
      <div
        className="w-full flex flex-col px-10 py-10 dark:text-white"
        style={{ minHeight: "100vh" }}
      >
        <div className="flex">
          <h1 className="text-3xl font-bold">Daftar Kuesioner</h1>
        </div>

        <div className="flex flex-col">{renderData()}</div>
      </div>
    </>
  );
}
